import React, { useState, useEffect } from 'react';
import { FiX, FiSave, FiFileText } from 'react-icons/fi';
import { callsAPI } from '../../services/api';
import { formatClockDate } from '../../utils/formatters';
import toast from 'react-hot-toast';

export default function CallNoteModal({ call, onClose, onSave, readOnly = false }) {
  const [notes, setNotes] = useState(call?.notes || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setNotes(call?.notes || '');
  }, [call]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await callsAPI.updateNotes(call.id, notes);
      toast.success('Saqlandi');
      if (onSave) onSave(notes);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Saqlashda xato');
    } finally {
      setSaving(false);
    }
  };

  if (!call) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <FiFileText size={20} color="#3b82f6" />
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>Qo'ng'iroq notasi</h3>
          </div>
          <button onClick={onClose} style={styles.closeBtn}><FiX size={18} /></button>
        </div>

        <div style={styles.info}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Raqam:</span>
            <span style={styles.infoValue}>
              {call.contact_name || (call.direction === 'inbound' ? call.caller_number : call.called_number)}
              {call.contact_name && (
                <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--text-muted)', fontFamily: 'monospace' }}>
                  ({call.direction === 'inbound' ? call.caller_number : call.called_number})
                </span>
              )}
            </span>
          </div>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Vaqt:</span>
            <span style={styles.infoValue}>
              {formatClockDate(call.call_date)}
            </span>
          </div>
          {call.operator_name && (
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Operator:</span>
              <span style={styles.infoValue}>{call.operator_name}</span>
            </div>
          )}
        </div>

        <div>
          <label style={styles.label}>Izoh</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            disabled={readOnly}
            style={styles.textarea}
            placeholder="Qo'ng'iroq haqida eslatma yozing..."
            autoFocus={!readOnly}
            rows={6}
          />
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
            {notes.length} belgi
          </div>
        </div>

        <div style={styles.footer}>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            {readOnly ? "Yopish" : "Bekor qilish"}
          </button>
          {!readOnly && (
            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleSave}
              disabled={saving}
            >
              <FiSave size={14} /> {saving ? "Saqlanmoqda..." : "Saqlash"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, backdropFilter: 'blur(4px)',
  },
  modal: {
    background: '#1e293b', border: '1px solid #2d3a4f',
    borderRadius: 16, padding: 24, width: '100%', maxWidth: 520,
    maxHeight: '90vh', overflow: 'auto',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: 20,
  },
  closeBtn: {
    background: 'transparent', border: 'none', color: 'var(--text-muted)',
    cursor: 'pointer', padding: 4,
  },
  info: {
    background: '#0f172a', borderRadius: 10, padding: 16,
    marginBottom: 20, border: '1px solid #2d3a4f',
  },
  infoRow: {
    display: 'flex', marginBottom: 6, fontSize: 13,
  },
  infoLabel: {
    color: 'var(--text-muted)', width: 80, flexShrink: 0,
  },
  infoValue: {
    color: 'var(--text-primary)', fontWeight: 500,
  },
  label: {
    fontSize: 13, fontWeight: 600, color: 'var(--text-muted)',
    marginBottom: 6, display: 'block',
  },
  textarea: {
    width: '100%', padding: '10px 12px',
    background: '#0f172a', border: '1px solid #2d3a4f',
    borderRadius: 8, color: '#f1f5f9',
    fontSize: 14, fontFamily: 'inherit',
    outline: 'none', resize: 'vertical',
    boxSizing: 'border-box',
  },
  footer: {
    display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20,
  },
};
